<template>
    <ul :class="noStyle ? 'list-unstyled' : 'list'">
        <li
            v-for="index in texts.length"
            :id="index"
            :key="texts[index-1]"
            :class="additionalListClasses"
            v-html="texts[index-1]"
        />
    </ul>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

export default defineComponent({
    name: "BulletList",
    props: {
        noStyle: {
            type: Boolean,
            default: false
        },
        texts: {
            type: Array as PropType<string[]>,
            required: true
        },
        additionalListClasses: {
            type: String,
            required: false,
            default: null
        }
    }
});
</script>
